import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.css'],
  standalone: false
})
export class SlideToggleComponent {

  @Output()
  onChangeEvent = new EventEmitter<MatSlideToggleChange>();

  @Output()
  onClickEvent = new EventEmitter<MouseEvent>();

  @Input()
  label!: string;

  @Input()
  value!: boolean;

}
